import * as React from 'react';
import { BaseButton as Button } from '../../../BaseComponents';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';

export interface Props {
	text: string;
	onAgree: React.DispatchWithoutAction;
	onDisagree: React.DispatchWithoutAction;
}

const AiPredictionFooter: React.FC<Props> = ({text, onAgree, onDisagree}) => {
	const { AiPredictionFooter: theme } = useTheme('AIPurchasePredictionService');
	const { t } = useTranslation('AIPurchasePredictionService');

	return (
		<div className={theme.footer}>
			<Button variant={'secondary'} onClick={onDisagree}>
				{text}
			</Button>
			<Button variant={'action'} onClick={onAgree}>
				{t('Add and pay')}
			</Button>
		</div>
	);
};

export default AiPredictionFooter;
